import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { PageListParams } from '../api/pages-api';
import { PAGE_FILTER_FIELDS, PAGE_SORTS } from '../components/page-filters';

/** URL search params of the pages list; mirrors GET /admin/v1/stores/{storeId}/pages. */
export const pageListSearchSchema = indexSearchSchema(PAGE_FILTER_FIELDS, { sort: PAGE_SORTS });

export type PageListSearch = z.infer<typeof pageListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function pageListParams(search: PageListSearch): PageListParams {
  return listParams(search, PAGE_FILTER_FIELDS);
}
